module.exports = __webpack_public_path__ + "static/media/IconTemplates_-29.72cb7490.svg";